/*
  ビジネスWiFi｜Wi-Fi規格別アクセスポイントラインナップのタブ切り替え
  sections/custom-wifi-lineup.liquid 専用。

  - HTMLは全パネルを表示した状態で出力される。ここでタブを表示し、非選択パネルを hidden にする。
    （JavaScriptが無効な場合は全商品が縦並びで表示されたまま）
  - パネルの id はアンカーID（例: wifi7-lineup）。URLハッシュと一致するタブを開いてスクロールする。
  - タブを直接クリックした場合は history.replaceState でハッシュだけ更新し、履歴は増やさない。
  - ページ内リンク（SELECT BY GENERATION）による遷移はブラウザ標準の履歴動作のまま、hashchange で追従する。
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-wifi-lineup]';

  function initLineup(root) {
    if (!root || root.wifiLineupTabs) return;

    var tablist = root.querySelector('[data-wifi-lineup-tablist]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wifi-lineup-tab]'));
    var panels = tabs.map(function (tab) {
      return root.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
    });

    // タブとパネルの対応が取れない場合は何もしない（全商品を縦並びで表示したままにする）
    if (!tablist || tabs.length < 2 || panels.some(function (p) { return !p; })) return;

    panels.forEach(function (panel, i) {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabs[i].id);
    });
    tablist.hidden = false;
    root.classList.add('is-tabbed');

    function indexOfPanelId(id) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].id === id) return i;
      }
      return -1;
    }

    function select(index, options) {
      var opts = options || {};
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        // hidden にしたパネル内の商品リンクはフォーカス対象から外れる
        panels[i].hidden = !on;
      });
      if (opts.focus) tabs[index].focus();
      if (opts.updateHash && window.history && window.history.replaceState) {
        var url = window.location.pathname + window.location.search + '#' + panels[index].id;
        window.history.replaceState(window.history.state, '', url);
      }
      if (opts.scroll) {
        // 表示を切り替えた後のレイアウトでスクロールする（scroll-margin-top で固定ヘッダー分を空ける）
        window.requestAnimationFrame(function () {
          panels[index].scrollIntoView({ block: 'start' });
        });
      }
    }

    function currentHashId() {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return '';
      try {
        return decodeURIComponent(hash.slice(1));
      } catch (e) {
        return hash.slice(1);
      }
    }

    // URLハッシュに対応するタブを開く。対応しないハッシュの場合は false を返す
    function syncFromHash(scroll) {
      var index = indexOfPanelId(currentHashId());
      if (index < 0) return false;
      select(index, { scroll: scroll });
      return true;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i, { updateHash: true });
      });
      tab.addEventListener('keydown', function (event) {
        var next = -1;
        switch (event.key) {
          case 'ArrowRight':
            next = (i + 1) % tabs.length;
            break;
          case 'ArrowLeft':
            next = (i - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = tabs.length - 1;
            break;
          default:
            return;
        }
        event.preventDefault();
        select(next, { focus: true, updateHash: true });
      });
    });

    function onHashChange() {
      if (!syncFromHash(true) && !currentHashId()) {
        // ハッシュなしの状態に戻った場合は初期タブを表示する（スクロールはブラウザに任せる）
        select(0);
      }
    }

    window.addEventListener('hashchange', onHashChange);

    // 初期表示：ハッシュが一致すればそのタブ、なければ先頭（Wi-Fi 7）
    if (!syncFromHash(true)) select(0);

    root.wifiLineupTabs = {
      select: select,
      panels: panels,
      destroy: function () {
        window.removeEventListener('hashchange', onHashChange);
      },
    };
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches(ROOT_SELECTOR)) initLineup(context);
    Array.prototype.forEach.call(context.querySelectorAll(ROOT_SELECTOR), initLineup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopifyテーマエディター：セクション再描画・ブロック選択に追従
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector(ROOT_SELECTOR);
    if (root && root.wifiLineupTabs) root.wifiLineupTabs.destroy();
  });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    if (!root || !root.wifiLineupTabs) return;
    var index = root.wifiLineupTabs.panels.indexOf(event.target);
    if (index >= 0) root.wifiLineupTabs.select(index, { scroll: true });
  });
})();
